import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $id: String!
    $data: PumpingSystemUpdateInput!
  ) {
    updateOnePumpingSystem(
      where: {
        id: $id
      }
      data: $data
    ) {
      id
    }
  }
`

export default () => (
  useMutation(MUTATION, `Sistema de bombagem actualizado`, mutationTypes.UPDATE)
)

